import { unifiedReviewsApiUrl } from '@settings';

export const getUnifiedReviewsUrl = (): string => {
	if (SERVER) {
		return require('@server/settings').serverSettings.unifiedReviewsApiUrl;
	}

	return unifiedReviewsApiUrl;
};
